import { Layout } from "antd";
import React from "react";
import "./AuthedLayout.less";

const { Header } = Layout;

const AppHeader = ({ ...props }) => {
  return <Header className="site-layout-background" style={{ padding: 0 }} />;
};

export default AppHeader;
